import type { Filter, FilterState } from "./types";

export function getActiveCount(filter: Filter, values: FilterState): number {
  const val = values[filter.id];
  if (!val) return 0;
  if (filter.type === "checkbox") return (val as string[]).length;
  const [lo, hi] = val as [number, number];
  return lo !== filter.min || hi !== filter.max ? 1 : 0;
}

export function applyFilterChange(
  filter: Filter | undefined,
  activeFilters: FilterState,
  id: string,
  value: string[] | [number, number],
): FilterState {
  if (filter?.type === "slider" && Array.isArray(value) && typeof value[0] === "number") {
    const [lo, hi] = value as [number, number];
    if (lo === filter.min && hi === filter.max) {
      return Object.fromEntries(Object.entries(activeFilters).filter(([k]) => k !== id));
    }
  }
  return { ...activeFilters, [id]: value };
}

export function removeFilter(activeFilters: FilterState, id: string, value?: string): FilterState {
  if (value !== undefined) {
    const current = (activeFilters[id] ?? []) as string[];
    const updated = current.filter((v) => v !== value);
    return updated.length === 0
      ? Object.fromEntries(Object.entries(activeFilters).filter(([k]) => k !== id))
      : { ...activeFilters, [id]: updated };
  }
  return Object.fromEntries(Object.entries(activeFilters).filter(([k]) => k !== id));
}
